import {
  schemaTypes,
  dateFormat,
  fuelTypeMap,
} from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor, stripLoc } from "../../../helpers/helperFunctions";
import {
  flipRange,
  canShowRangeSwitch,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
import _ from "lodash";
import humanizeDuration from "humanize-duration";
// import mixpanel from "mixpanel-browser";
import actions from "../../../store/actions";
import moment from "moment";

const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: "shortEn",
  languages: {
    shortEn: {
      y: () => "y",
      mo: () => "mo",
      w: () => "w",
      d: () => "d",
      h: () => "h",
      m: () => "m",
      s: () => "s",
      ms: () => "ms",
    },
  },
});

const preProcessData = (respObj) => {
  let oldrespObj = {};
  for (let idx in respObj) {
    let item = respObj[idx];
    if (!(item.vehicleid in oldrespObj)) {
      oldrespObj[item.vehicleid] = [];
    }
    oldrespObj[item.vehicleid].push(item);
  }

  return oldrespObj;
};

export const processData = (respObj, vehicleMap, callback, noFilter) => {
  let historyData = [];
  let locationbodyfrom = [];
  let locationbodyto = [];

  for (let vehiclepath in respObj) {
    let vehicleno = vehicleMap[vehiclepath].vehicleno;
    let model = vehicleMap[vehiclepath].vehiclechassisno
      ? vehicleMap[vehiclepath].vehiclechassisno
      : "";

    for (let ridx in respObj[vehiclepath]) {
      let eachitem = respObj[vehiclepath][ridx];
      let starttime =
        eachitem.starttime != null
          ? moment(eachitem.starttime).format(dateFormat)
          : null;
      let endtime =
        eachitem.endedtime != null
          ? moment(eachitem.endedtime).format(dateFormat)
          : null;
      let total_can_distance =
        eachitem.total_can_distance != null
          ? parseFloat(eachitem.total_can_distance.toFixed(2))
          : null;
      let total_gps_distance =
        eachitem.total_gps_distance != null
          ? parseFloat(eachitem.total_gps_distance.toFixed(2))
          : null;
      let total_duration = shortEnglishHumanizer(eachitem.total_duration, {
        largest: 2,
      });
      let ignstatus = eachitem.ignstatus === 1 ? "Moving" : "Stopped";
      let istripcomplete = eachitem.istripcomplete
        ? "Completed"
        : "In Progress";
      let startloc =
        "(" +
        String(eachitem.startlat) +
        ", " +
        String(eachitem.startlng) +
        ")";
      let endloc =
        "(" + String(eachitem.endlat) + ", " + String(eachitem.endlng) + ")";

      let EndLatLng = [eachitem.endlat, eachitem.endlng];
      let StartLatLng = [eachitem.startlat, eachitem.startlng];
      locationbodyfrom.push([eachitem.startlat, eachitem.startlng]);
      locationbodyto.push([eachitem.endlat, eachitem.endlng]);
      historyData.push({
        total_can_distance,
        total_gps_distance,
        total_duration,
        vehicleno,
        model,
        starttime,
        endtime,
        StartLatLng,
        EndLatLng,
        startloc,
        endloc,
        istripcomplete,
        ignstatus,
      });
    }
  }

  callback(historyData);
  GeoCodeAPIs.getAddress(locationbodyfrom).then(
    (resp) => {
      for (let idx in historyData) {
        historyData[idx].startloc =
          (resp[idx] ? resp[idx][1] : "") +
          " (" +
          historyData[idx].startloc +
          ")";
      }
      callback(historyData, true, false);
    },
    (resp) => {
      console.log(resp);
    }
  );
  GeoCodeAPIs.getAddress(locationbodyto, schema).then(
    (resp) => {
      for (let idx in historyData) {
        historyData[idx].endloc =
          (resp[idx] ? resp[idx][1] : "") +
          " (" +
          historyData[idx].endloc +
          ")";
      }
      callback(historyData, false, true);
    },
    (resp) => {
      console.log(resp);
    }
  );
};

const getHistory = (schema, data, store) => {
  window.getButtonClicked = true;
  window.resetIndex();
  schema.showPage = true;
  schema.finalData = null;
  let saveState = null;
  let tableStateData = null;
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  let vehicleDataForReport = {};
  let fixedQueryLimit = 700;
  let splitedVehicles = [];
  let vehicleids = [];
  let vehiclenos = [];
  data.vehicle =
    window.selectedItems && window.selectedItems.length
      ? window.selectedItems
      : window.itemClicked
      ? window.selectedVehicles
      : window.selectedVehicles && window.selectedVehicles.length
      ? window.selectedVehicles
      : [];
  // data.vehicle =  window.selectedVehicles ? window.selectedVehicles : []
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (endtime - starttime > 1000 * 60 * 60 * 24 * 35) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 35 days",
        content: "You can't select date range of more than 35 days",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (starttime >= endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  let days = endtime - starttime;
  schema.count = 0;
  days = Math.ceil(days / 86400000); //total days
  let queryLimit = data.vehicle.length * days * 10; // total query limit
  schema.count = Math.ceil(queryLimit / fixedQueryLimit); // page number
  schema.splitCount = parseInt(data.vehicle.length / schema.count); // total vehicle / total pages
  if (schema.splitCount > 50) schema.splitCount = 50;

  let getReportBody = {
    starttime: starttime,
    endtime: endtime,
  };
  if (!window.selectAllClicked) {
    // if(data.vehicle.length <=50){
    getReportBody.vehicle = data.vehicle.map((item) => {
      return item.data.vehicleid;
    });
  }
  if (window.setReportWindowTabBusy)
    window.setReportWindowTabBusy(schema, true);
  ReportAPIs.getReportVehicles(getReportBody)
    .then((resp) => {
      vehiclenos = resp;
      data.vehicle.map((item) => {
        vehiclenos.map((id) => {
          if (item.id === id) {
            vehicleids.push(item.name);
          }
        });
      });
      let startIndex = 0;
      let endIndex = schema.splitCount;
      for (let pages = 0; pages < schema.count; pages++) {
        let page = [];
        for (let idx in vehicleids) {
          if (idx >= startIndex && idx <= vehicleids.length) {
            if (idx <= endIndex - 1) page.push(vehicleids[idx]);
          }
        }
        splitedVehicles.push(page);
        startIndex = endIndex;
        endIndex = startIndex + schema.splitCount;
        if (pages === schema.count - 1 && startIndex <= vehicleids.length) {
          if (vehicleids.length - startIndex > 0) {
            schema.count++;
          }
        }
      }
      if (data.vehicle && data.vehicle.length) {
        const handleSuccess = (resp) => {
          // window.dataForAll = resp;
          // if (window.setReportWindowTabBusy)
          //   window.setReportWindowTabBusy(schema, false);
          let oldrespObj = preProcessData(resp);
          let noFilter = true;
          processData(
            oldrespObj,
            store.vehicleMap,
            (data, from, to) => {
              if (from !== undefined && to !== undefined) {
                if (from) window.locFrom = true;
                if (to) window.locTo = true;
              }
              schema.finalData = data;
              vehicleDataForReport = {
                endtime: endtime,
                starttime: starttime,
                newTripVehicles: splitedVehicles,
                reportName: schema.key,
                tripFirstDataNew: data,
                selectedVehicles: data.vehicle,
                tripPagenoNew: data.length ? schema.count : 0,
                showPage: schema.showPage,
                selectedTripVehicles: data.vehicle,
              };
              store.dispatch({
                type: actions.SELECTED_VEHICLE_ID,
                data: vehicleDataForReport,
              });
              if (tableStateData && tableStateData[0]) {
                tableStateData[0].body = data;
                tableStateData[0].busy = false;
                saveState(
                  tableStateData[0],
                  tableStateData[1],
                  tableStateData[2]
                );
              }
              if (schema.content[0].ref) {
                if (window.locFrom && window.locTo)
                  schema.content[0].ref.setData(data);
              }
            },
            noFilter
          );
        };

        if (schema.content[0].ref) {
          schema.content[0].ref.setBusy(true);
          saveState = schema.content[0].ref.props.saveState;
          tableStateData = [
            schema.content[0].ref.state,
            schema.content[0].ref.props.schemaKey,
            schema.content[0].ref.props.data,
          ];
        }
        let body = {
          vehicleno: splitedVehicles[0],
          starttime: starttime,
          endtime: endtime,
        };
        if (window.showNoGpsFixData === true) {
          body.fixqfilter = false;
        }
        ReportAPIs.newPrecomputeTrips(body).then(handleSuccess, (r) => {
          handleSuccess({});
        });
      } else {
        window.graphDataErr = "";

        window.dataForAll = null;
        window.graphDataErr = "Please Select Vehicle";

        if (window.InMapForceUpdate) {
          window.InMapForceUpdate();
        }
        if (window.InGraphControlForceUpdate) {
          window.InGraphControlForceUpdate();
        }
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
        return;
      }
    })
    .catch(() => {
      console.log("failed");
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "Data Fetching Failed",
          content: "Data fetching failed",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
    });
  // mixpanel.track("User Looks For Trip Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[4].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});

const download = (schema, data, store) => {
  // mixpanel.track("User Downloads Trip Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  let strictColumns =
    store.groupTree.children.filter((g) => (g.path || "").indexOf("1259") > -1)
      .length > 0; // kushalsslp
  let filterdData = schema.content[0].ref.state.body;
  if (filterdData) {
    let finalData = _.map(filterdData, (r) => {
      r = Object.assign({}, r);
      r.starttime = moment(r.starttime).format(dateFormat);
      r.endtime = moment(r.endtime).format(dateFormat);
      if (strictColumns) {
        r.startloc = stripLoc(r.startloc);
        r.endloc = stripLoc(r.endloc);
      }
      return r;
    });
    if (strictColumns) {
      finalData = _.map(finalData, (r) => {
        if (window.userInfo.SELF.pbl_report === "SHOW") {
          let head = schema.content[0].head;
          let newHead = [];
          for (let idx in head) {
            if (
              head[idx].key !== "cpk" &&
              head[idx].key !== "mileage" &&
              head[idx].key !== "idlingtime" &&
              head[idx].key !== "acidlingtime"
            ) {
              newHead.push(head[idx].key);
            }
          }
          return _.pick(r, newHead);
        }
        let headings = schema.content[0].head
          .filter((c) => (c.isShowable ? c.isShowable() : true))
          .map((c) => c.key);
        return _.pick(r, headings);
      });
    }

    let heads = schema.content[0].head;
    let removeHeads = [];
    let evOnly = window.userInfo.SELF.EV_ONLY;
    let evConfig = window.userInfo.SELF.enable_EV_trip_report;
    let disableHeadEV = [
      "cpk",
      "mileage",
      "fuelprice",
      "idlingtime",
      "acidlingtime",
    ];
    let removeHead = [
      "idlingtime",
      "acidlingtime",
      "tripscore",
      "startdte",
      "enddte",
      "uid",
      "starttime__processed__",
      "endtime__processed__",
      "fuelused",
      "ophours",
      "consumption",
      "cph",
    ];
    if (evOnly === "DISABLE" || evConfig) {
      removeHeads = removeHead.concat(disableHeadEV);
    } else {
      removeHeads = removeHead;
      removeHeads.push("status");
    }
    heads = heads.filter((head) => {
      if (!removeHeads.includes(head.key)) {
        return head;
      }
    });
    schema.newData = [];
    for (let idx in finalData) {
      let tempdata = {};
      for (let rdx in heads) {
        if (heads[rdx].key in finalData[idx]) {
          let key = heads[rdx].key;
          let name = heads[rdx].name;
          tempdata[name] = finalData[idx][key];
        }
      }
      schema.newData.push(tempdata);
    }
    setTimeout(() => {
      JSONToCSVConvertor(schema.newData, "TripReport", false);
    }, 500);
  }
};

const schema = {
  key: "new_trip_report",
  name: "Night Round Report",
  showPage: false,
  count: null,
  splitCount:null,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      maxCount: 6000,
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
      hideTime: false,
      schemaKey: "new_trip_report",
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
      model: Date.now() - 1000 * 60,
      hideTime: false,
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Trip Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
      tooltip: "Download Page",
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "vehicleno", name: "", name: "Vehicle No" },
        { key: "model", name: "Chassis No" },
        {
          key: "starttime",
          name: "Start Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        {
          key: "endtime",
          name: "End Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        { key: "total_duration", name: "Duration" },
        { key: "total_can_distance", name: "CAN Distance (km)" },
        { key: "total_gps_distance", name: "GPS Distance (km)" },
        { key: "ignstatus", name: "Status" },
        { key: "istripcomplete", name: "Trip" },

        {
          key: "startloc",
          name: "Start Location",
          width: 2,
          onClick: (d, item) => {
            window.showInGoogleMaps(item.StartLatLng[0], item.StartLatLng[1]);
          },
        },
        {
          key: "endloc",
          name: "End Location",
          width: 2,
          onClick: (d, item) => {
            window.showInGoogleMaps(item.EndLatLng[0], item.EndLatLng[1]);
          },
        },
      ],
    },
  ],
};
export default schema;
